<template>
<v-container fluid class="secondary">
    
  
    <v-card solo elevation="5" class="pa-4 primary" >
      <h1 class="d-flex justify-center textTitle--text font-weight-black ma-5 pa-3">{{ $t('addproduct.screenTitle', { '1': formTitle }) }}</h1>
      <v-form >
        <v-card v-if="form1" class="tertiary pa-3">
        <v-text-field :label="$t('addproduct.prodName')" v-model="prodname" background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
         <v-text-field :label="$t('addproduct.prodCode')" v-model="codigo" background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
         <v-text-field :label="$t('addproduct.prodDesc')" v-model="proddesc" background-color="quinty" height="60px" color="primary"  rounded class="font-weight-black text-h6 ma-2 pa-2 shrink"></v-text-field>
         
       <v-card class="secondary ma-5 pa-5 justify-center"> 
         <v-card-title class="justify-center align-center"> 
         <h2 class="textTitle--text font-weight-black">{{ $t('addproduct.prodPuBuy') }}</h2> 
         </v-card-title>
         <v-row class="justify-center align-center"> 
         <v-col cols="5">
           <v-text-field  type="number" v-model.number="pu_buy" min="0" prefix="Q." background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
         
       </v-col>
         <v-col cols="5">
           <v-select v-model="fournisseurPu" :items="fournDb" :item-text="'name'" :label="$t('addproduct.supplier')" background-color="quinty" class="primary--text mx-5 pa-3 font-weight-black" solo >
                <template v-slot:append-outer>
                  <v-btn small rounded class="info" @click="manageFournisseurDialog=!manageFournisseurDialog">!</v-btn>
                  <v-dialog v-model="manageFournisseurDialog" width="80%" :retain-focus="false">
                      <manageFournisseur :key="buyForm" />
                    </v-dialog>   
                </template>
                                </v-select>
         </v-col> 
         </v-row> 
         <v-card-actions class="justify-center">
         <v-btn @click="checkpreciocompramayor=true" class="primary--text font-weight-black quaterny" color="quaterny">{{ $t('addproduct.puBuyMayorTitle') }}</v-btn>
          </v-card-actions>       
       </v-card>
         
       <v-dialog
       :retain-focus="false"
         v-model="checkpreciocompramayor"
         width="80%"
       >
       <addPrecioCompraMayor :precioscomprasmayor="preciospormayorbuy" @update="updatepreciospormayorbuy"/>
        
       </v-dialog>
        
        <v-card class="secondary ma-5 pa-5 justify-center"> 
          <v-card-title class="justify-center align-center"> 
         <h2 class="textTitle--text font-weight-black d-flex justify-center">{{ $t('addproduct.prodPuSell') }}</h2> 
          </v-card-title>
         <v-row class="justify-center align-center"> 
         <v-col cols="5">
           <v-text-field type="number" v-model.number="pu_sell" min="0" prefix="Q." background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
           </v-col>
         
         <v-col cols="5" class="d-flex justify-center">
            
           <v-btn @click="checkprecioventamayor=true" class="primary--text font-weight-black quaterny" color="quaterny">{{ $t('addproduct.puSellMayorTitle') }}</v-btn>
           
         </v-col>         
       </v-row>
        </v-card>
       <v-dialog
       :retain-focus="false"
         v-model="checkprecioventamayor"
         width="80%"
         class="grey lighten-3"
       > 
       <addPrecioVentaMayor :preciosventasmayor="preciospormayorsell" @update="updatepreciospormayorsell"/>
        
       </v-dialog>
          <v-row class="justify-center ma-3 pa-3">
         <v-btn class="success ma-3 pa-8 font-weight-black black--text text-h5" large @click="validateForm1">{{ $t('addproduct.selectCatButton') }}</v-btn>
         </v-row>
         </v-card>
         
         <v-card v-if="form2" class="tertiary">
           <v-row class="justify-center ma-2 pa-2">
              <v-btn class="ma-2 pa-2 font-weight-black black--text" small color="quinty" elevation="24" @click="manageCat">{{ $t('addproduct.catFormTitle') }}</v-btn>
            </v-row>
            <v-treeview
            :items="treeviewCatItems"
            activatable
            :multiple-active="false" 
            :active.sync="catactive" 
            return-object
            active-class="textMenu font-weight-black black--text"
            open-all
            expand-icon="mdi-plus secondary quinty--text ma-3 pa-3"
            
            hoverable
            class="quaterny ma-3 pa-3 font-weight-black textTable--text"
          ><template v-slot:append="{ item }">
              <v-chip small>{{item.qtyprod}}</v-chip>
            </template></v-treeview>  
          <v-dialog v-model="manageCatDialog" width="80%" :retain-focus="false">
                 <catManager :key="catform"/>
               </v-dialog>
         
        <v-row class="justify-center">
         <v-card solo elevation="5" class="ma-5 pa-4 secondary" width="80%" v-if="this.catactive[0]">
        <h1 class="d-flex justify-center textTitle--text font-weight-black ma-5 pa-3">{{ $t('addproduct.inv') }}</h1>
        <v-row class="justify-center align-center">
          <v-col cols="6">
            <h2 class="ma-2 d-flex justify-end textMenu--text">{{ $t('addproduct.invInit') }}</h2>
          </v-col>
          <v-col cols="6 d-flex justify-start">
            <v-text-field @change="checkLimitInvQty" type="number" min=0 max="1000000" v-model.number="initInv" background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
        
          </v-col>
        </v-row>
        <v-row class="justify-center align-center">
          <v-col cols="6">
            <h2 class="ma-2 d-flex justify-end textMenu--text">{{ $t('addproduct.invRequest') }}</h2>
          </v-col>
          <v-col cols="6 d-flex justify-start">
            <v-text-field @change="checkLimitInvQty" type="number" min="0" max="1000000" v-model.number="requestInv" background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
        
          </v-col>
        </v-row>
        <v-row class="justify-center align-center">
          <v-col cols="6">
            <h2 class="ma-2 d-flex justify-end textMenu--text">{{ $t('addproduct.invAlert') }}</h2>
          </v-col>
          <v-col cols="6 d-flex justify-start">
            <v-text-field @change="checkLimitInvQty" type="number" min="0" max="100" v-model.number="catactive[0].invAlert" background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
        
          </v-col>
        </v-row>

        

        </v-card>
        </v-row>
         <v-row class="justify-center align-center">
            <v-btn @click="form2=false;form1=true;formTitle='1 - General'" elevation="24" class="info ma-3 pa-8 font-weight-black black--text text-h5" large>{{ $t('back') }}</v-btn>
            <v-btn class="ma-3 pa-8 font-weight-black black--text text-h5" large color="success" elevation="24" @click="confirmCatChoice">{{ $t('addproduct.confirmCatButton') }}</v-btn>
         
         <v-dialog :retain-focus='false' width="550px" v-model="errorSelectCat">
              <errorMessage @close="errorSelectCat=false" :title="'Error'" :message="'Por favor, tienes que selectionar una categoria'" :key="errorKey"/>
            </v-dialog>
         
         </v-row>

         </v-card>

         <v-card v-if="form3" class="primary">
           <v-row class="justify-center align-center">
             <v-col cols="5" class="ma-2 pa-2">
               <v-card elevation="8" class="ma-2 pa-2 secondary">
                  <v-row class="justify-center align-center"><h3 class="textTitle--text font-weight-black">{{ $t('addproduct.prodProps') }}</h3></v-row>
               <v-row class="justify-center align-center">
                 <v-sheet elevation="5" class="ma-2 pa-2 tertiary">
               <v-chip-group
                column
                class="quaterny pa-2"
                v-model="propactiveprod"
                return-object
                mandatory
              >
                <v-chip
                  v-for="prop in prodprops"
                  :key="prop.id"  
                  :value="prop"
                  class="primary textMenu--text pa-3 font-weight-black"  
                  active-class="black"     
                            
                >
                  {{ prop.name }}
                </v-chip>
              </v-chip-group>
              </v-sheet>
              </v-row>
              <v-row class="justify-center align-center">
              <v-btn class="ma-1 font-weight-black black--text" color="error" small elevation="3" solo @click="removePropFromProd">{{ $t('addproduct.removeProp') }}</v-btn>
              </v-row>
               </v-card>
               
             </v-col>
              <v-col cols="5" class="ma-2 pa-2">
               <v-card elevation="8" class="ma-2 pa-2 secondary">
                  <v-row class="justify-center align-center"><h3 class="textTitle--text font-weight-black">{{ $t('addproduct.propsDispo') }}</h3></v-row>
               <v-row class="justify-center align-center">
                 <v-sheet elevation="5" class="ma-2 pa-2 tertiary">
               <v-chip-group
                column
                multiple
                class="quaterny"
                v-model="selectedpropsdb"
                return-object
                
                
              >
                <v-chip
                  v-for="prop in propsDb"
                  :key="prop.id"  
                  
                  :value="prop"    
                  class="primary textMenu--text pa-3 font-weight-black"    
                  
                  active-class="black"        
                >
                  {{ prop.name }}
                </v-chip>
              </v-chip-group>

              </v-sheet>
              </v-row>
              <v-row class="justify-center align-center">
                            <v-btn class="ma-1 font-weight-black black--text" color="success" elevation="3" small solo @click="addPropToProd">{{ $t('addproduct.addProp') }}</v-btn>
                            <v-btn class="ma-1 font-weight-black black--text" color="info" elevation="3" small solo @click="manageProp">{{ $t('addproduct.configProp') }}</v-btn>
              </v-row>
               </v-card>
               <v-dialog v-model="managePropDialog" width="80%" :retain-focus="false">
                 <propManager :key="propform"/>
               </v-dialog>
               
             </v-col>
           </v-row>
           <v-row class="justify-center align-center ma-3 pa-3">
             <v-col cols="10">
           <v-card elevation="5" solo class="ma-2 pa-2 secondary">
             <v-card-title class="justify-center font-weight-black textTitle--text">{{ $t('addproduct.propValues') }}</v-card-title>
            <div v-for="propis in prodprops" :key="propis.id">
              <v-row v-if="propis.typeform==$t('propmanager.selectOption2')" class="pa-4 mx-3 align-center justify-center">
                
                <h2 class="font-weight-black textTitle--text text-decoration-underline">{{propis.name}} : </h2>
                <v-text-field type="number" v-model.number="propis.value" background-color="quinty"  class="ml-3 pa-1 font-weight-black primary--text shrink text-h6" outlined solo></v-text-field>            
              
              </v-row>
              <v-row v-if="propis.typeform==$t('propmanager.selectOption1')" class="pa-4 mx-3 align-center justify-center">
                
                <h2 class="font-weight-black textTitle--text text-decoration-underline">{{propis.name}} : </h2>
                <v-text-field type="text" v-model="propis.value"  background-color="quinty"  class="ml-3 pa-1 font-weight-black primary--text shrink text-h6" solo outlined></v-text-field>            
              
              </v-row>
              <v-row v-if="propis.typeform==$t('propmanager.selectOption3')" class="pa-4 mx-3 align-center justify-center">
                
                <h2 class="font-weight-black textTitle--text text-decoration-underline">{{propis.name}} : </h2>
                <v-select
                v-model="propis.value" 
                background-color="quinty"  
                class="ma-1 pa-1 font-weight-black primary--text shrink text-h6"
                :items="propis.selectoptions"
                outlined
              ></v-select> 
              </v-row>
                   
            </div>   
         </v-card>
         </v-col>
           </v-row>
         <v-row class="justify-center align-center">
           <v-btn @click="form3=false;form2=true;formTitle='2 - Categoria'" x-large elevation="24" class="info ma-3 pa-8 font-weight-black black--text text-h5" large>{{ $t('back') }}</v-btn>
         <v-btn @click="CheckProduct" x-large elevation="24" class="success ma-3 pa-8 font-weight-black black--text text-h5" large>{{ $t('addproduct.confirmPropsButton') }}</v-btn>
         </v-row>
         </v-card>


         <v-card v-if="form4" class="secondary pa-5">
            <v-card elevation="12" class="ma-8 pa-2 tertiary">
              <v-row class="justify-center">
              <v-card flat width="70%" class="pa-5 tertiary">
              <v-row class="mx-4 my-2 justify-space-between align-center">
                
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('addproduct.prodCode') }}</h2>
                       <h2 class="ml-5 font-weight-bold textTitle--text">{{testproduct.codigo}}</h2>
                    
                     </v-row>
                     <v-row class="mx-4 my-2 justify-space-between align-center">
                
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('addproduct.prodName') }}</h2>
                       <h2 class="ml-5 font-weight-bold textTitle--text">{{testproduct.name}}</h2>
                    
                     </v-row>
                     <v-row class="mx-4 my-2 justify-space-between align-center">
                
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('addproduct.prodDesc') }}</h2>
                       <h2 class="ml-5 font-weight-bold textTitle--text">{{testproduct.desc}}</h2>
                    
                     </v-row>
                     <v-row class="mx-4 my-2 justify-space-between align-center">
                
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('addproduct.prodPuBuy') }}</h2>
                       <h2 class="ml-5 font-weight-bold textTitle--text">{{ $t('addproduct.qCon', { '1': testproduct.pu_buy, '2': testproduct.vendedor }) }}</h2>
                    
                     </v-row>
                     <v-row class="mx-4 my-2 justify-space-between align-center">
                
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('addproduct.prodPuSell') }}</h2>
                       <h2 class="ml-5 font-weight-bold textTitle--text">Q.{{testproduct.pu_sell}}</h2>
                    
                     </v-row>
                     <v-row class="mx-4 my-2 justify-space-between align-center">
                
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('addproduct.prodCat') }}</h2>
                       <h2 class="ml-5 font-weight-bold textTitle--text">{{catactive[0].name}}</h2>
                    
                     </v-row>
                    
                     </v-card>
                     </v-row>
             
             </v-card>
              <v-row class="justify-center align-center">
           <v-card elevation="12" class="ma-4 pa-2 quaterny">
               
                 <v-row class="justify-center"><h2 class="font-weight-black primary--text">{{ $t('addproduct.inv') }}</h2></v-row>
                 <v-row class="mx-4 my-2 justify-space-between align-center">
                
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('addproduct.invInit') }}</h2>
                       <h2 class="ml-5 font-weight-bold textTitle--text">{{ $t('addproduct.unit', { '1': testproduct.initInv }) }}</h2>
                    
                     </v-row>
                      <v-row class="mx-4 my-2 justify-space-between align-center">
                
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('addproduct.invRequest') }}</h2>
                       <h2 class="ml-5 font-weight-bold textTitle--text">{{ $t('addproduct.unit', { '1': testproduct.requestInv }) }}</h2>
                    
                     </v-row>
                      <v-row class="mx-4 my-2 justify-space-between align-center">
                
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('addproduct.invAlert') }}</h2>
                       <h2 class="ml-5 font-weight-bold textTitle--text">{{testproduct.invAlert}}%</h2>
                    
                     </v-row>
                </v-card>
         </v-row>
         <v-row class="justify-center align-center">
           <v-card elevation="12" class="ma-4 pa-2 quaterny">
               <div v-if="testproduct.preciospormayorbuy.length">
                 <v-row class="justify-center"><h2 class="font-weight-black primary--text">{{ $t('addproduct.puBuyMayorTitle') }}</h2></v-row>
                <v-data-table
                  dense
                  :headers="headerspreciomayorbuy"
                  :items="testproduct.preciospormayorbuy"
                  item-key="id"
                  class="elevation-5 tertiary pa-3 ma-5 textTable--text font-weight-black text-h3"
                ></v-data-table>
               </div>
               <div v-else><v-row class="justify-center align-center ma-3 pa-3 "><h2 class="textTitle--text">{{ $t('addproduct.noPubuyMayorMessage') }}</h2></v-row></div>
             </v-card>
         </v-row>
         <v-row class="justify-center align-center">
           <v-card elevation="12" class="ma-2 pa-2 quaterny">
              
               <div v-if="testproduct.preciospormayorsell.length">
                 <v-row class="justify-center"><h2 class="font-weight-black primary--text">{{ $t('addproduct.puSellMayorTitle') }}</h2></v-row>
                 <v-data-table
                  dense
                  :headers="headerspreciomayor"
                  :items="testproduct.preciospormayorsell"
                  item-key="id"
                  class="elevation-5 tertiary pa-3 ma-5 textTable--text font-weight-black text-h3"
                ></v-data-table>
               </div>
               <div v-else><v-row class="justify-center align-center ma-3 pa-3 "><h2 class="textTitle--text">{{ $t('addproduct.noPusellMayorMessage') }}</h2></v-row></div>
             </v-card>
         </v-row>
         <v-row class="justify-center align-center">
           <v-card elevation="12" class="ma-2 pa-2 quaterny">
               <div v-if="testproduct.props.length">
                 <v-row class="justify-center"><h2 class="font-weight-black primary--text">{{ $t('addproduct.prodProps') }}</h2></v-row>
                 <v-data-table
                  dense
                  :headers="headersprops"
                  :items="testproduct.props"
                  item-key="id"
                  class="elevation-5 tertiary pa-3 ma-5 textTable--text font-weight-black text-h3 text-center"
                ></v-data-table>
               </div>
               <div v-else><v-row class="justify-center align-center ma-3 pa-3 "><h2 class="textTitle--text">{{ $t('addproduct.noPropMessage') }}</h2></v-row></div>
             </v-card>
         </v-row>
         <v-row class="justify-center align-center">
           
             <v-card elevation="18" class="ma-5 pa-3 tertiary">
               <v-row class="justify-center align-center">
                 <v-col cols="12" class="d-flex justify-center">
                   <v-btn class="ma-3 pa-10 font-weight-black black--text text-h3 " rounded x-large @click="addProduct" solo color="success">{{ $t('addproduct.confirmProdButton') }}</v-btn></v-col>

                </v-row>  
                <v-row class="justify-center align-center pa-4">
                  <v-col cols="5" class="d-flex justify-center"><v-btn large rounded class="ma-3 pa-8 font-weight-black black--text text-h5" @click="form4=false;form1=true;formTitle='1 - General'" solo color="info">{{ $t('back') }}</v-btn></v-col>
                  <v-col cols="5" class="d-flex justify-center"><v-btn large rounded class="ma-3 pa-8 font-weight-black black--text text-h5" @click="closeForm" solo color="error">{{ $t('close') }}</v-btn></v-col>
                </v-row>
             </v-card>
            
         </v-row>
         </v-card>
      </v-form>
    </v-card>
</v-container>
</template>

<script>
          
import propManager from "@/components/propManager"
import catManager from "@/components/catManager"
import manageFournisseur from "@/components/manageFournisseur"
import addPrecioCompraMayor from "@/components/addPrecioCompraMayor"
import addPrecioVentaMayor from "@/components/addPrecioVentaMayor"
import errorMessage from '@/components/errorMessage'

import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'

export default {
    components:{propManager,catManager,manageFournisseur,addPrecioCompraMayor,addPrecioVentaMayor,errorMessage},
    data () {
        return {
          form1:true,
          form2:false,
          form3:false,
          form4:false,
            checkprecioventamayor:false,
            checkpreciocompramayor:false,
            prodname:'',
            pu_buy:0,
            codigo:'',
            initInv:0,
            pu_sell:0,
            proddesc:'',
            prodprops:[],
            preciospormayorbuy:[],
            preciospormayorsell:[],
            
            temparray:[],
            categories:[],
            propsdb:[],
            catactive:[],
            selectedpropsdb:[],
            propactiveprod:{},

            testproduct:{},

            valproptext:'',
            valpropnum:0,
            valpropselect:'',

            products:[],
            managePropDialog:false,
            propform:0,
            manageCatDialog:false,
            catform:0,
            fournisseurPu:'',

            fournisseursDb:[],
            fournisseur:'',
            
            manageFournisseurDialog:false,
            buyForm:0,
            formTitle:'1 - General',
            errorSelectCat:false,
            errorKey:0,

            requestInv:0,

          }
    },
    computed:{
      headerspreciomayor(){
         var headerspreciomayor= [
              { text: this.$i18n.t('headers.unitPrice'),align: 'start',value: 'pu',class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center'},
              { text: this.$i18n.t('headers.qtyNeed'), value: 'qty',class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center' },
              ]
              return headerspreciomayor},
      headerspreciomayorbuy(){
         var headerspreciomayorbuy= [
              { text: this.$i18n.t('headers.unitPrice'),align: 'start',value: 'pu',class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center'},
              { text: this.$i18n.t('headers.qtyNeed'), value: 'qty',class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center' },
              { text: this.$i18n.t('headers.supplier'), value: 'vendedor',class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center' },
              ]
              return headerspreciomayorbuy},
        headersprops(){
         var headersprops= [
              { text:  this.$i18n.t('headers.propName'),align: 'start',value: 'name'},
              { text: this.$i18n.t('headers.propValue'), value: 'value' },
              ]
              return headersprops},    
        ...mapGetters({
        prodList:'prodList',
        catdb:'catdb',
        propsDb:'propsDb',
        fournDb:'fournDb',
        treeviewCatItems:'treeviewCatDb'
      })
            

    },
    watch: {
    },
    created() {
      
    },
    mounted() {
          
        },
    methods:{
      checkLimitInvQty(){
        if(this.initInv>1000000){this.initInv=1000000}
        if(this.requestInv>1000000){this.requestInv=1000000}
        if(this.catactive[0].invAlert>100){this.catactive[0].invAlert=100}
      },
      manageFournisseur(){
          this.buyForm+=1;
          this.manageFournisseurDialog=true;
        },
      manageProp(){
        this.propform+=1
        this.managePropDialog=true
      },
      manageCat(){
        this.catform+=1
        this.manageCatDialog=true
      },
      confirmCatChoice(){
        if(this.catactive[0]){
        
        this.form2=false;
        this.form3=true;
        this.formTitle=this.$t('addproduct.titleFormProps')
        }else{this.errorSelectCat=true}
      },
      validateForm1(){
        this.form1=false;
        this.form2=true
        this.formTitle=this.$t('addproduct.titleFormCat')
      },
      CheckProduct(){
        this.form3=false;
        this.form4=true;
        this.formTitle=this.$t('addproduct.titleFormVerif')

        var name=this.prodname;
        var desc=this.proddesc;
        var id = 'prod';
            var proddb = this.prodList;
            var props = []
            var i

        // ajoute l'item en verifiant l'id. si l'id existe, continue d'essayer jusqu'a trouver un id valide, 
        // permet de remplir les vides laisser par les suppressions precedentes
        if(proddb){
            var size = proddb.length
            
            var pos=1

            for(i=1;i<size;i++){
              if(proddb[i].id!=id){continue}else{
                pos+=1
                id='prod'+pos
                i=0
              }
            }} 
          if(this.prodprops.length){
          size=this.prodprops.length;
            for(i=0;i<size;i++){
              props.push(JSON.parse(JSON.stringify(this.prodprops[i])))
            }}
          var pusell = this.pu_sell
          var pumayorsell = this.preciospormayorsell
          var pumayorbuy = this.preciospormayorbuy
          var pubuy = this.pu_buy
          var codigo = this.codigo
          var initInv = this.initInv

          var catname = this.catactive[0].name
          var catid = this.catactive[0].id

          this.testproduct={id:id,
                            codigo:codigo,
                            name:name,
                            vendedor:this.fournisseurPu,
                            desc:desc,
                            pu_buy:pubuy,
                            pu_sell:pusell,
                            preciospormayorbuy:pumayorbuy,
                            preciospormayorsell:pumayorsell,
                            props:props,
                            initInv:initInv,
                            currenttInv:initInv,
                            requestInv:this.requestInv,
                            invAlert:this.catactive[0].invAlert,
                            catid:catid,
                            catname:catname,}

      },
      updatepreciospormayorbuy(v){

        this.preciospormayorbuy=v
        //console.log(v)
      },
      updatepreciospormayorsell(v){

        this.preciospormayorsell=v
        //console.log(v)
      },
      addProduct(){
        var name=this.prodname;
        var desc=this.proddesc;
        var id = 'prod1';
            var proddb = this.prodList;
            var props = []
            var i
        
        // ajoute l'item en verifiant l'id. si l'id existe, continue d'essayer jusqu'a trouver un id valide, 
        // permet de remplir les vides laisser par les suppressions precedentes
        if(proddb){
          var size = proddb.length
          console.log("size pords : ",size)
            var pos=1

            for(i=0;i<size;i++){
              if(proddb[i].id!=id){continue}else{
                pos+=1
                id='prod'+pos
                i=0
              }
            }
            } 
          size=this.prodprops.length;
            for(i=0;i<size;i++){
              props.push(JSON.parse(JSON.stringify(this.prodprops[i])))
            }
          var pusell = this.pu_sell
          var pumayorsell = this.preciospormayorsell
          var pumayorbuy = this.preciospormayorbuy
          var pubuy = this.pu_buy
          var codigo = this.codigo
          var initInv = this.initInv

          var catid = this.catactive[0].id
          var catname = this.catactive[0].name

          console.log("id : ",id)
          var product={
            'id':id,
            'codigo':codigo,
            'name':name,
            'vendedor':this.fournisseurPu,
            'desc':desc,
            'pu_buy':pubuy,
            'pu_sell':pusell,
            'price_mayor_sell':pumayorsell,
            'price_mayor_buy':pumayorbuy,
            'initInv':initInv,
            'currenttInv':initInv,
            'requestInv':this.requestInv,
            'invAlert':this.catactive[0].invAlert,
            'catid':catid,
            'catname':catname,
          }
          for(var y=0;y<props.length;y++){
            product[props[y].name]=props[y].value;
          }

          this.addProd(product)

          this.clearform();
          this.form4=false;
          this.form1=true;
          this.$emit('dialogend');

      },
      closeForm(){
        this.clearform();
        this.form4=false;
          this.form1=true;
          this.$emit('dialogend');
          this.formTitle=this.$t('addproduct.titleFormGeneral')
          //this.$emit('modfyingproduct', false)     
          },
      clearform(){
        this.prodname='';
        this.proddesc='';
        this.initInv=0;
        this.codigo='';
        this.catactive=[];
        this.pu_sell=0;
        this.pu_sellmayor=[];
        this.pu_buy=0;
        this.pu_buymayor=[];
        this.prodprops=[];
        this.formTitle=this.$t('addproduct.titleFormGeneral');
        this.fournisseurPu='';
      },
      
      
     
        removePropFromProd(){
          var id = this.propactiveprod.id;
          this.temparray=[];
          if(id!=null){
            var size = this.prodprops.length; 
            for(var i=0;i<size;i++){
              if(this.prodprops[i].id!=id){
                    this.temparray.push(this.prodprops[i])
              }                  
            }
            this.prodprops=this.temparray;
            
          }
        },
        addPropToProd(){
          this.temparray=[];
          var size = this.selectedpropsdb.length; 
          var sizeprodprop = this.prodprops.length; 
          var has=0;
          if(size!=null){
            this.temparray=this.prodprops;
            for(var i=0;i<size;i++){
              has=0;
              for(var u=0;u<sizeprodprop;u++){
                if(this.selectedpropsdb[i].id==this.prodprops[u].id){has=1}
                   
              }
              if(has==0){ this.temparray.push(this.selectedpropsdb[i])}
            }
            this.prodprops=this.temparray;
          }
        },
        ...mapActions([
        'addProd'
      ]),

    }
}
</script>